import React from "react";
import { RCCHookToast, RCCIcon, RCCServicesApi, RCCTooltip } from "react-common-components";
import Xarrow from "react-xarrows";
import { useConfirmModal } from "src/context/ConfirmModal/context";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";
import { IArrow } from "./interface";

const Arrow: React.FC<IArrow> = ({
	onCallbackDeleteCauseEffect,
	idMap,
	metba005,
	showDelete
}) => {
	const { translate } = useTranslation();
	const {confirm} = useConfirmModal();
	const {addToast} = RCCHookToast();
    
	const submitDelete = (mea005Id: number, mea003Id: number) => {
		confirm(
			translate("Exclusão de Causa/Efeito"), 
			translate("Deseja realmente excluir a Causa/Efeito?"),
			async () => {
				await RCCServicesApi.deleteRequest({
					method: "Maps/DeleteCauseEffect",
					urlParameters: {
						id: mea005Id,
						idMap
					}
				});

				onCallbackDeleteCauseEffect(mea003Id, mea005Id);

				addToast({
					color: "green",
					description: translate("Causa/Efeito excluída com sucesso"),
					title: translate("Sucesso")
				});
			},
			(err) => {
				standardErrorMessages(err, translate("Erro ao excluir Causa/Efeito"), addToast);
			},
			true
		);
	};

	const btnDelete = (mea005Id: number, mea003Id: number) => (
		<>
			<RCCTooltip
				text={translate("Excluir Relação")}	
				color="red"			
			>
				<RCCIcon
					name="trash"
					color="var(--red)"
					size={18}
					onClick={() => {submitDelete(mea005Id, mea003Id);}}
				/>
			</RCCTooltip>
		</>
	);

	const defProps = {
		passProps: {
			className: "xarrow",
			cursor: "pointer"
		}
	};

	return (
		<>
			<Xarrow {...defProps}
				start={String(metba005.mea005Mea003Id)}
				end={String(metba005.mea005Mea003Id2)}
				path="smooth"
				curveness={0.8}
				color="white"
				strokeWidth={2}
				labels={{middle: showDelete ? btnDelete(metba005.mea005Id, metba005.mea005Mea003Id) : ""}}
				tailColor="red"
				tailShape="circle"
				tailSize={2}
				showTail
				zIndex={1}
			/>
		</>
	);
};

export default Arrow;
